import { createReduxAsyncThunk } from 'shared/utils';

import { mapApi } from '../../api';

import { MAP_STATE } from '../../constants';

import { PlannedRoutes, PlannedRouteStationsFilter, PlannedRouteStations } from '../../types';

interface GetPlannerRoutesStationsArg {
  planId: PlannedRoutes['planId'];
  filter: PlannedRouteStationsFilter;
}

export const getPlannerRoutesStations = createReduxAsyncThunk<PlannedRouteStations[], GetPlannerRoutesStationsArg>(
  `${MAP_STATE}/getPlannerRoutesStations`,
  async ({ planId, filter }) => {
    const { data: { routeStations } } = await mapApi.getPlannerRoutesStations(planId, filter);
    return routeStations;
  }
);
